import type Highcharts from 'highcharts';
import { type Options } from 'highcharts';

import { COLOR_BLUE_200 } from '@/styles/palette';

import { type FlareChart, type FlareProps } from '../types';

const initializeOptions = (
  options: Options | undefined,
  {
    title,
    subtitle,
    description,
    colors,
    inverted,
    chartMarginTop,
    chartMarginBottom,
    chartMarginLeft,
    chartMarginRight,
    spacingTop,
    spacingBottom,
    spacingLeft,
    spacingRight,
    postRender,
  }: Partial<FlareProps>,
): Highcharts.Options => {
  return {
    colors,
    ...options,
    chart: {
      backgroundColor: 'transparent',
      spacingLeft,
      spacingRight,
      spacingTop,
      spacingBottom,
      marginTop: chartMarginTop,
      marginBottom: chartMarginBottom,
      marginLeft: chartMarginLeft,
      marginRight: chartMarginRight,
      inverted,
      ...options?.chart,
      events: {
        render: postRender && ((event) => postRender?.(event.target as unknown as FlareChart)),
        ...options?.chart?.events,
      },
      style: {
        fontFamily: '"Inter", sans-serif',
        ...options?.chart?.style,
      },
    },
    title: {
      text: title,
      ...options?.title,
      style: {
        fontSize: '16px',
        ...options?.title?.style,
      },
    },
    subtitle: {
      text: subtitle,
      ...options?.subtitle,
    },
    accessibility: {
      description,
      keyboardNavigation: {
        focusBorder: {
          style: {
            lineWidth: 4,
            color: COLOR_BLUE_200,
            borderRadius: '5px',
          },
        },
      },
      ...options?.accessibility,
    },
    plotOptions: {
      series: {
        ...options?.plotOptions?.series,
      },
      ...options?.plotOptions,
    },
    credits: {
      enabled: false,
      ...options?.credits,
    },
    legend: {
      enabled: false,
      ...options?.legend,
    },
  };
};

export default initializeOptions;
